import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image21 from "../../../../assets/images/Blog30/image21 NAs100 Aug top still to come_.png";
import image40 from "../../../../assets/images/Blog30/image40 vol up in equities not bonds.png";
import image61 from "../../../../assets/images/Blog30/image61 trump powell 1.png";
import image62 from "../../../../assets/images/Blog30/image62 trump powell 2.png";
import image43 from "../../../../assets/images/Blog30/image43 WIRP us rate cut odds.png";
import image44 from "../../../../assets/images/Blog30/image44 CMEtool.png";
import image26 from "../../../../assets/images/Blog30/image26 nfp _ 100k rate cuts.png";
import image24 from "../../../../assets/images/Blog30/image24 nfp by sector.png";
import image28 from "../../../../assets/images/Blog30/image28 jolts unhire.png";
import image27 from "../../../../assets/images/Blog30/image27 BLS evidence for the prosecution.png";
import image35 from "../../../../assets/images/Blog30/image35 tariff card renewal.png";
import image65 from "../../../../assets/images/Blog30/image65 Nas100 NQ expected pullback.png";
import image48 from "../../../../assets/images/Blog30/image48 silver lease rate squeeze.png";
import image49 from "../../../../assets/images/Blog30/image49 Corporate Treasury BTC taking over (1).png";
import image16 from "../../../../assets/images/Blog30/imageNumber16.png";
import image15 from "../../../../assets/images/Blog30/image15 Q2 scorecard.png";
import image23 from "../../../../assets/images/Blog30/image23 Berkshire top.png";
import image29 from "../../../../assets/images/Blog30/image29 JOlts misdirection.png";
import image34 from "../../../../assets/images/Blog30/image34 PCE rents v tariff goods.png";
import image45 from "../../../../assets/images/Blog30/image45 Gold 3 wave grind (1).png";

const Blog30 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – August 4th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Jobs Shock, Fed Firestorm & Gold on the Move</p>
        <p>
          Markets stumbled hard into August as the macro floor gave way beneath a richly priced equity rally. With NFP revisions rattling the Fed and political pressure mounting, the stage is set for
          a volatile mid-month reversal—or one last squeeze into seasonal highs.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: A Rally Interrupted by Reality</p>
              <p>
                What started as a textbook grind-up turned into the <span className="highlightedText">worst week for equities since May 2023.</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">S&P 500</span>: -2.4%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Nasdaq 100:</span>: -2.4%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Dow Jones</span>: -3.0%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Russell 2K</span>: -4.4%
                  </p>
                </li>
              </ul>
              <p>
                The <span className="highlightedText">tech-led advance</span> hit resistance as the Nasdaq brushed the top of its rising channel. Last week’s correction aligns with our
                <span className="highlightedText"> mid-August seasonal top</span> scenario—likely a final leg higher remains before summer peaks.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                But it's not just price exhaustion. <span className="highlightedText">Breadth is narrowing, </span>volatility is reawakening, and macro support is fraying.
                <span className="highlightedText">VIX broke above 20, </span> while bond market volatility stayed oddly low—a telltale divergence.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Cash levels remain high, which could support a bounce, but chasing here is risky.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Fed in the Crosshairs, Jobs Collapse</p>
              <p className="highlightedText">Powell Dodges, Trump Reloads</p>
              <p>
                Last week’s
                <span className="highlightedText"> FOMC meeting passed quietly,</span> but the real fireworks came after.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed Governor Kugler resigned,</span> giving Trump a free slot to install a dovish voter.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Two dissenters (Waller & Bowman)</span> openly opposed Powell, first time in decades.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Trump is now publicly pressuring Powell to resign, escalating the political war on Fed independence.</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image61}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image61)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image62}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image62)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The market got the message. <span className="highlightedText"> Rate cut odds for September are now 92%,</span> per Bloomberg’s WIRP and CME’s FedWatch tools.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image43}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image43)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Jobs: The Dam Broke</p>
              <p>
                The <span className="highlightedText">July NFP print (73k)</span> was a shock, but the bigger surprise was the{" "}
                <span className="highlightedText">massive downward revisions—258,000 jobs were erased,</span> the worst revision since 1978.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Over the last 3 months, the economy has added just <span> 35k jobs/month—</span>a near stall. Hiring has collapsed.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This isn’t just weak data—it’s a political earthquake. Trump sacked BLS Chief Erika McEntarfer after the release, raising even more questions about
                <span className="highlightedText"> data integrity and Fed independence.</span>
              </p>
            </div>
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Tariffs: Weaponised Again</p>
              <p>
                The average <span>tariff rate was raised to 15.2%,</span> with some countries like Switzerland hit with 39%. Trump also <span>accelerated the de minimis threshold rule</span> to Aug
                29, 2025—four years early.
              </p>
              <p>Expect ripple effects on inflation, margins, and consumer sentiment, especially in Q3.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: A Fragile Setup</p>
              <p>While equity indices remain in uptrends, the structure is deteriorating:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>SPX is grinding higher but stalling</p>
                </li>
                <li className="themesPointer">
                  <p>Nasdaq is stretched but not broken</p>
                </li>
                <li className="themesPointer">
                  <p>VIX has popped</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Semis are still leading,</span> but risk appetite is showing signs of reversal
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image65}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image65)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Meanwhile, <span>gold and silver are quietly gaining steam.</span> Rising geopolitical tensions, fiscal dominance, and Fed turmoil are powering up real assets.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image48}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image48)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Crypto—especially <span className="highlightedText">BTC</span> —also saw renewed inflows as macro hedges came back into focus.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This is classic <span className="highlightedText">late-cycle behaviour</span>—speculative excess on one hand, safety rotation on the other.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <p className="highlightedBoldText">Last Week’s Recap: Earnings Hold Up, Macro Doesn’t</p>
            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Earnings: Strong Beats, Even in Tech</p>
              <p>Despite the broader weakness, earnings were a bright spot:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">66% of SPX has reported</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">81% beat rate</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Q2 EPS growth revised to 11.2%,</span> up from 5.8% forecast
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">Apple, Meta, Microsoft, and Amazon</span> all posted strong results, although the latter stumbled on outlook. Apple is playing a longer AI game, while
                peers are going heavy on CapEx.
              </p>
              <p>
                Meanwhile, <span className="highlightedText">Berkshire Hathaway posted a rare disappointment,</span> writing down Kraft Heinz and posting a 59% drop in net income.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Macro Data: Warnings Were There</p>
              <p>
                The JOLTS report previewed the <span className="highlightedText"> NFP revisions collapse</span> with a <span className="highlightedText">261k hiring drop,</span> the second-lowest
                since 2020. <span className="highlightedText"> PCE remained sticky,</span> but the composition showed offsetting forces—
                <span className="highlightedText">tariffed goods vs falling shelter costs.</span>
              </p>
              <p>
                The <span className="highlightedText">ISM manufacturing miss</span> also signalled softening demand and suggests the Fed is behind the curve.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Fed Fallout, Global PMIs & UK Decision</p>
              <p>Another heavy macro week lies ahead—Fed commentary, global PMIs, and UK rate decisions take the spotlight.</p>

              <p className="highlightedText">Monday, August 4</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>UK (Scotland) Bank Holiday</p>
                </li>

                <li className="themesPointer">
                  <p>Canada Civic Holiday</p>
                </li>
                <li className="themesPointer">
                  <p>CHF CPI</p>
                </li>
                <li className="themesPointer">
                  <p>USD Durable Goods, Factory Orders</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, August 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global Services PMIs (US, EZ, UK, CNY, JPY)</p>
                </li>
                <li className="themesPointer">
                  <p>USD ISM Services</p>
                </li>
                <li className="themesPointer">
                  <p>USD Atlanta GDPNow Q3 estimate</p>
                </li>
                <li className="themesPointer">
                  <p>USD Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>Oil API Weekly Inventory</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Earnings: <span className="highlightedText">Pfizer, BP, CAT, AMD, SNAP, Rivian, Opendoor</span>
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, August 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>NZD Employment Data</p>
                </li>
                <li className="themesPointer">
                  <p>EZ Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>USD Mortgage Applications</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Earnings: <span className="highlightedText">Uber, Shopify, Disney, McDonald’s, Duolingo, DraftKings</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Fed Speakers:<span className="highlightedText"> Daly, Cook, Collins</span>
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, August 7</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>BoE Rate Decision (expected hold at 4.25%)</p>
                </li>
                <li className="themesPointer">
                  <p>GBP Halifax HPI</p>
                </li>
                <li className="themesPointer">
                  <p>USD Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>USD Productivity & Unit Labour Costs</p>
                </li>
                <li className="themesPointer">
                  <p>USD Consumer Credit</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Earnings:<span className="highlightedText"> Eli Lilly, ConocoPhillips, Sony, Pinterest, Twilios</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Central Bank Speakers: <span className="highlightedText"> ECB Rehn, BOE Bailey, FOMC Bostic</span>
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, August 8</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CAD Employment Data</p>
                </li>
                <li className="themesPointer">
                  <p>JPY Household Spending</p>
                </li>
                <li className="themesPointer">
                  <p>CHF Consumer Climate</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Earnings: <span className="highlightedText"> Wendy’s, Terawulf</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Fed Speaker: <span className="highlightedText"> Musalme</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Prepping for the Mid-August Pivot</p>
              <p>Markets are wobbling—but the bigger risk may still lie ahead. Beneath the surface, the late-cycle warning signs are flashing:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Breadth is collapsing— <span className="highlightedText">7 stocks = 32% of SPX cap</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Job market revisions destroyed the “soft landing” story</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Fed independence is under attack—<span className="highlightedText">Powell vs Trump</span> showdown looms
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Tariffs are back, and inflation risks may re-emerge</p>
                </li>
                <li className="themesPointer">
                  <p>Gold, silver, and BTC are quietly outperforming</p>
                </li>
              </ul>
              <p>
                Still, liquidity remains high, earnings are beating, and the rally could grind out one final leg into the August peak—
                <span className="highlightedText">unless the Fed breaks first.</span>
              </p>
              <p className="highlightedBoldText">Our stance: </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Stay long, high-quality, large caps,</span> but tighten stops into strength
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Add BTC, gold, and silver </span> on pullbacks—macro hedges are back in play
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Watch Wednesday–Friday closely: </span>UK rate decision, ISM Services, and Fed speakers will steer the tone
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1-MIF9DUvZkKTKbDMLcpt2Nn2dNE4XXiZmWCdnKi6y_o/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog30;
